import React, { useState } from "react";
import { PrimaryBlueButton, Severity } from "@velaro/velaro-component-lib";
import useApi from "@/hooks/useApi";
import useAIConfigs from "@/hooks/useAIConfigs";
import useToastAlert from "@/hooks/useToastAlert";
import { useParams, useNavigate } from "react-router-dom";

export default function AINewSaveChatbotButton() {
  const { id } = useParams();
  const { aiConfigurations } = useAIConfigs();
  const api = useApi();
  const toastAlert = useToastAlert();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    const config = aiConfigurations.find((c) => c.id === parseInt(id!));
    if (!config) {
      toastAlert.displayToast(Severity.Error, "Configuration not found");
      return;
    }

    setSaving(true);
    try {
      const isNew = config.id === 0;
      const response = isNew
        ? await api.messaging.post("AIConfiguration", config)
        : await api.messaging.put("AIConfiguration", config);

      if (response.ok) {
        toastAlert.displayToast(Severity.Success, "Chatbot saved successfully");
        if (isNew) {
          const newConfig = await response.json();
          navigate(`/ai-new/settings/general/${newConfig.id}`);
        }
      } else {
        toastAlert.displayToast(Severity.Error, "Failed to save chatbot");
      }
    } catch (error) {
      console.error("Save error:", error);
      toastAlert.displayToast(Severity.Error, "An error occurred while saving");
    } finally {
      setSaving(false);
    }
  };

  return (
    <PrimaryBlueButton
      label={saving ? "Saving..." : "Save"}
      onClick={handleSave}
      disabled={saving}
    />
  );
}
